import CollectionProvider from 'providers/collection/CollectionProvider';
import React from 'react';
import CollectionCarousel from 'src/components/collection/CollectionCarousel';
import FullWidthSectionWrapper from 'src/components/layout/components/FullWidthSectionWrapper';
import Layout from 'src/components/layout/Layout';
import { LayoutSection } from 'src/components/layout/Layout.types';
import { CollectionData } from 'types/models';
import { FANCY_GRAPHICS_COLLECTION_IDS } from 'utils/constants';
import { GAP_SIZE_REM, SECTION_GAP_REM, slugify } from 'utils/global';
import { LANDING_PAGE_COLLECTIONS } from 'utils/landingPageData';
import { getCollectionPageMetadata } from 'utils/metadata.utils';
import pageStrings from 'utils/strings/pageStrings';
import CollectionContainer from './CollectionContainer';
import CollectionHeader from './CollectionHeader';
import CollectionHeaderV2 from './CollectionHeaderV2';
import CollectionSplashscreenBackground from './CollectionSplashscreenBackground';
import { UNSORTED_TOPICS } from 'utils/metatopics.constants';

interface CollectionPageProps {
  collection: CollectionData;
  isInitialLoggedIn: boolean;
}

// DEPRECATED

const CollectionPage: React.FC<CollectionPageProps> = ({
  collection,
  isInitialLoggedIn,
}) => {
  const collectionTitleSection: LayoutSection = {
    content: FANCY_GRAPHICS_COLLECTION_IDS.includes(collection.id) ? (
      <FullWidthSectionWrapper height="calc(100vh - 96px)">
        <CollectionHeaderV2 />
      </FullWidthSectionWrapper>
    ) : (
      <CollectionHeader roundedHeaderImage={true} />
    ),
    isFullscreen: FANCY_GRAPHICS_COLLECTION_IDS.includes(collection.id),
  };

  const collectionSourcesSection: LayoutSection = {
    content: <CollectionContainer />,
  };

  const moreCollectionsSection: LayoutSection = {
    content: (
      <CollectionCarousel
        items={LANDING_PAGE_COLLECTIONS.filter(
          coll => coll.id !== collection.id,
        )}
        sectionTitle={{
          preTitle: pageStrings.landing.sourcesHeader.preTitle,
          title: pageStrings.landing.sourcesHeader.title,
        }}
        mb={{ base: GAP_SIZE_REM, md: SECTION_GAP_REM }}
      />
    ),
    isFullscreen: true,
  };

  return (
    <CollectionProvider
      collection={collection}
      isInitialRequestLoggedIn={isInitialLoggedIn}
    >
      {FANCY_GRAPHICS_COLLECTION_IDS.includes(collection.id) && (
        <CollectionSplashscreenBackground collectionId={collection.id} />
      )}
      <Layout
        pageMetadata={getCollectionPageMetadata({ collection })}
        sections={[
          collectionTitleSection,
          collectionSourcesSection,
          moreCollectionsSection,
        ]}
        breadcrumbs={
          !!collection.hashtags?.length
            ? [
                {
                  title: 'Home',
                  link: '/',
                },
                {
                  title:
                    UNSORTED_TOPICS[collection.hashtags[0]]?.title ??
                    collection.hashtags[0],
                  link: '/topic/' + collection.hashtags[0],
                },
                {
                  title: collection.name,
                  link: `/collection/${collection.id}/${slugify(
                    collection.name,
                  )}`,
                },
              ]
            : undefined
        }
      />
    </CollectionProvider>
  );
};

export default CollectionPage;
